import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'surveym-star',
  templateUrl: './star.component.html',
  styles: []
})
export class StarComponent {

  @Input() isSelected = false;
  @Input() isHovered = false;
  @Input() description = '';

  @Output() onSelected = new EventEmitter();
  @Output() onHoverd = new EventEmitter<boolean>();

  get iconClasses(): string {
    if (this.isSelected) {
      return 'tk-i-star-blue';
    }
    return this.isHovered ? 'tk-i-star-border-blue' : 'tk-i-star-border-white';
  }

  onClick() {
    this.isSelected = true;
    this.onSelected.emit(this.isSelected);
  }

  onMouseEnter() {
    this.isHovered = true;
    this.onHoverd.emit(true);
  }

  onMouseLeave() {
    this.isHovered = false;
    this.onHoverd.emit(false);
  }
}
